import { FC } from 'react';

import { ModalTitle } from '../../../StreamModalWrapper';

import { BackArrow, Wrapper } from './Wrapper';

type HeaderProps = {
  title: string;
  onBack?(): void;
};

const Header: FC<HeaderProps> = ({ title, onBack }) => {
  return (
    <Wrapper>
      {onBack && <BackArrow onClick={onBack} />}
      <ModalTitle {...{ title }}></ModalTitle>
    </Wrapper>
  );
};

export default Header;
